// Schedules screen — manage scheduled reports, see run history, and clear the
// WhatsApp "tap to send" outbox. Reached from the header ⏰ REPORTS button and from
// the push alert link view:schedules.
import React, { useEffect, useState } from 'react';
import { apiGet, ScheduleModal } from '../components/ExportBar';

const API = '/api';
const tok = () => localStorage.getItem('dj_token');
async function call(path, method, body) {
  const r = await fetch(API + path, { method, headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tok()}` }, body: body ? JSON.stringify(body) : undefined });
  if (!r.ok) { let m = `HTTP ${r.status}`; try { m = (await r.json()).error || m; } catch {} throw new Error(m); }
  return r.json();
}
const fmtDt = d => d ? new Date(d).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—';
const small = { fontSize: 11, color: 'var(--text3)' };
const b = (on) => ({ padding: '4px 9px', borderRadius: 6, border: `1px solid ${on ? 'var(--gold)' : 'var(--border2)'}`, background: on ? 'var(--gold)' : 'none', color: on ? 'var(--on-gold)' : 'var(--text3)', fontSize: 10, fontWeight: 700, letterSpacing: .5, cursor: 'pointer' });
const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export default function SchedulesView({ Header, setView }) {
  const [tab, setTab] = useState('schedules');
  const [schedules, setSchedules] = useState(null);
  const [runs, setRuns] = useState(null);
  const [outbox, setOutbox] = useState(null);
  const [edit, setEdit] = useState(null);
  const [msg, setMsg] = useState('');
  const load = () => {
    apiGet('/reports/schedules').then(setSchedules).catch(e => setMsg(e.message));
    apiGet('/reports/runs').then(setRuns).catch(() => {});
    apiGet('/reports/outbox').then(setOutbox).catch(() => {});
  };
  useEffect(load, []);
  const pendingWa = (outbox || []).filter(o => o.status === 'MANUAL' || o.status === 'FAILED');

  const toggle = async (s) => { await call(`/reports/schedules/${s.id}`, 'PUT', { is_active: !s.is_active }); load(); };
  const del = async (s) => { if (!window.confirm(`Delete schedule "${s.title}"?`)) return; await call(`/reports/schedules/${s.id}`, 'DELETE'); load(); };
  const runNow = async (s) => {
    setMsg(`Running "${s.title}"…`);
    try {
      const r = await call(`/reports/schedules/${s.id}/run`, 'POST');
      setMsg(`${s.title}: ${r.status}`);
      (r.detail && r.detail.whatsapp || []).filter(w => w.status === 'MANUAL' && w.link).forEach((w, i) => setTimeout(() => window.open(w.link, '_blank'), i * 400));
    } catch (e) { setMsg(`Run failed: ${e.message}`); }
    load();
  };
  const markSent = async (o) => { await call(`/reports/outbox/${o.id}/sent`, 'POST'); load(); };
  const when = s => s.frequency === 'weekly' ? `Every ${DAYS[s.weekday ?? 1]} ${s.run_time}` : s.frequency === 'monthly' ? `Day ${s.day_of_month || 1} at ${s.run_time}` : `Daily ${s.run_time}`;

  return (
    <div className="screen">
      <Header subtitle="REPORTS · SCHEDULES" />
      <div style={{ padding: '12px 20px', display: 'flex', alignItems: 'center', gap: 12, borderBottom: '1px solid var(--border)' }}>
        <button onClick={() => setView('home')} style={{ background: 'none', border: 'none', color: 'var(--gold)', fontSize: 22, cursor: 'pointer', padding: 0 }}>←</button>
        <div>
          <div style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: 22, color: 'var(--gold)' }}>Scheduled Reports</div>
          <div style={small}>Open any report screen and press ⏰ SCHEDULE to add one.</div>
        </div>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
          <button style={b(tab === 'schedules')} onClick={() => setTab('schedules')}>SCHEDULES {schedules ? `(${schedules.length})` : ''}</button>
          <button style={b(tab === 'outbox')} onClick={() => setTab('outbox')}>WHATSAPP {pendingWa.length ? `(${pendingWa.length} to send)` : ''}</button>
          <button style={b(tab === 'runs')} onClick={() => setTab('runs')}>HISTORY</button>
          <button style={b(false)} onClick={load}>↻</button>
        </div>
      </div>
      {msg && <div style={{ padding: '6px 20px', fontSize: 12, color: 'var(--text2)' }}>{msg}</div>}

      {tab === 'schedules' && (
        <div style={{ padding: 12 }}>
          {schedules === null && <div className="loading">LOADING…</div>}
          {schedules && schedules.length === 0 && <div style={{ padding: 30, textAlign: 'center', ...small }}>No schedules yet.</div>}
          {(schedules || []).map(s => (
            <div key={s.id} className="card" style={{ marginBottom: 10, opacity: s.is_active ? 1 : .55 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 700 }}>{s.title}</div>
                  <div style={small}>{s.subtitle || 'no filters'}</div>
                  <div style={{ ...small, marginTop: 4 }}>{when(s)} · {String(s.formats).toUpperCase()} · via {s.channels} · by {s.created_by}</div>
                  <div style={small}>{s.channels.includes('email') && `✉ ${s.email_to} `}{s.channels.includes('whatsapp') && `🟢 ${s.wa_to}`}</div>
                  <div style={small}>Next: {fmtDt(s.next_run_at)} · Last: {fmtDt(s.last_run_at)} {s.last_status ? `(${s.last_status})` : ''}</div>
                </div>
                <div style={{ display: 'flex', gap: 6, alignItems: 'flex-start', flexWrap: 'wrap' }}>
                  <button style={b(false)} onClick={() => runNow(s)}>▶ RUN NOW</button>
                  <button style={b(false)} onClick={() => setEdit(s)}>✎ EDIT</button>
                  <button style={b(s.is_active)} onClick={() => toggle(s)}>{s.is_active ? 'ON' : 'OFF'}</button>
                  <button style={b(false)} onClick={() => del(s)}>🗑</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {tab === 'outbox' && (
        <div style={{ padding: 12 }}>
          <div style={{ ...small, marginBottom: 8 }}>Scheduled WhatsApp messages are prepared here with the file link. Tap OPEN WHATSAPP, send, then MARK SENT.</div>
          {outbox === null && <div className="loading">LOADING…</div>}
          {outbox && outbox.length === 0 && <div style={{ padding: 30, textAlign: 'center', ...small }}>Nothing in the outbox.</div>}
          {(outbox || []).map(o => (
            <div key={o.id} className="card" style={{ marginBottom: 8, display: 'flex', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap', opacity: o.status === 'SENT' ? .55 : 1 }}>
              <div>
                <div style={{ fontWeight: 700 }}>{o.title || 'Report'} → {o.number}</div>
                <div style={small}>{o.filename} · {fmtDt(o.created_at)} · {o.status}{o.error ? ` — ${o.error}` : ''}</div>
              </div>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                {o.wa_link && o.status !== 'SENT' && <a href={o.wa_link} target="_blank" rel="noreferrer" style={{ ...b(true), textDecoration: 'none' }}>🟢 OPEN WHATSAPP</a>}
                {o.file_url && <a href={o.file_url} target="_blank" rel="noreferrer" style={{ ...b(false), textDecoration: 'none' }}>📎 FILE</a>}
                {o.status !== 'SENT' && <button style={b(false)} onClick={() => markSent(o)}>✓ MARK SENT</button>}
              </div>
            </div>
          ))}
        </div>
      )}

      {tab === 'runs' && (
        <div style={{ padding: 12 }}>
          {runs === null && <div className="loading">LOADING…</div>}
          {(runs || []).map(r => (
            <div key={r.id} className="card" style={{ marginBottom: 8 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
                <div style={{ fontWeight: 700 }}>{r.title} <span style={{ ...small, fontWeight: 400 }}>({r.trigger_type})</span></div>
                <div style={{ fontSize: 11, fontWeight: 700, color: r.status === 'DONE' ? 'var(--green)' : r.status === 'FAILED' ? 'var(--red)' : 'var(--yellow)' }}>{r.status}</div>
              </div>
              <div style={small}>{fmtDt(r.created_at)} · {r.channels} · {r.recipients} · by {r.created_by}</div>
              {r.detail && r.detail.email && <div style={small}>Email: {r.detail.email.sent ? `sent to ${(r.detail.email.to || []).join(', ')}` : r.detail.email.error}</div>}
              {r.detail && r.detail.error && <div style={{ ...small, color: 'var(--red)' }}>{r.detail.error}</div>}
              {r.detail && r.detail.links && <div style={small}>{r.detail.links.map(l => <a key={l.token} href={l.url} target="_blank" rel="noreferrer" style={{ marginRight: 8 }}>{l.filename}</a>)}</div>}
            </div>
          ))}
        </div>
      )}

      {edit && <ScheduleModal existing={{ ...edit, channels: String(edit.channels), formats: String(edit.formats) }} reportKey={edit.report_key}
        spec={{ title: edit.title, subtitle: edit.subtitle, sections: [{ columns: edit.columns || [] }] }} source={edit.source}
        onClose={() => { setEdit(null); load(); }} />}
    </div>
  );
}
